export default "__VITE_ASSET__B6ZM5bcO__"